import React from 'react';
import useMediaQuery from 'helpers/hooks/useMediaQuery';
import { desktop } from 'helpers/utils/screensizes';

export interface Props {
  progress?: number;
}

const Loader: React.FC<Props> = ({ progress }) => {
  const [isDesktop] = useMediaQuery(desktop);
  const hasProgress = progress !== undefined;

  return (
    <div
      role="progressbar"
      aria-valuenow={hasProgress ? progress : undefined}
      aria-valuemin={hasProgress ? 0 : undefined}
      aria-valuemax={hasProgress ? 100 : undefined}
      className={`z-10 mx-0 flex h-[522px] flex-col items-center justify-center rounded-xl bg-[#eaeaea] ${isDesktop ? 'mx-24' : ''}`}
    >
      <p data-testid="loading" className="mb-4 text-lg font-regular text-gray-700">
        {'Loading'}
      </p>
      <div className="h-4 w-300 overflow-hidden rounded-full">
        <div
          data-testid="progress-value"
          className="h-full bg-[#e0356c] transition-all duration-300"
          style={{ width: `${hasProgress ? progress : 0}%` }}
        ></div>
      </div>
    </div>
  );
};

export default Loader;
